import React from 'react';

/**
 * @typedef {object} GraphTooltipPayload
 * @property {string} name
 * @property {number} value
 */

/**
 * @typedef {object} GraphTooltipProps
 * @property {boolean} [active]
 * @property {GraphTooltipPayload[]} [payload]
 * @property {string|number} [label]
 */

/**
 * @param {GraphTooltipProps} props
 */
const GraphTooltip = props => {
  const { active, payload, label } = props;

  if (!active || !payload?.length) {
    return null;
  }

  return (
    <div className='tooltip' data-testid='graph-tooltip'>
      <div>
        <strong>Year Q:</strong> {label}
      </div>
      {payload.map(entry => (
        <div key={entry.name}>
          <strong>{entry.name} Aggregate Value:</strong> {entry.value}
        </div>
      ))}
    </div>
  );
};

export default GraphTooltip;
